// extracted by mini-css-extract-plugin
export var sectionTitle = "area-selection-section-module--sectionTitle--06758";